import dynamic from "next/dynamic";
const OurPartners = dynamic(() => import("../components/OurPartners"));
const Form = dynamic(() => import("../components/Form"));
import Section01 from "../components/about/Section01";
const Section02 = dynamic(() => import("../components/about/Section02"));
const Section03 = dynamic(() => import("../components/about/Section03"));
import Head from "next/head";
import { NextSeo } from "next-seo";
import { client } from "../../lib/client";
import React from "react";

const SeoComponents = () => (
  <Head>
    <link rel="apple-touch-icon" href="apple-touch-icon.png" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link rel="icon" href="/favicon.ico" />
  </Head>
);

const About = ({ aboutPage }) => {
  const { seo, pageBuilder } = aboutPage;
  const { firstSection, fourthSection, ourPartners, secondSection } =
    pageBuilder;

  const { metaDescription, metaTitle } = seo;

  return (
    <>
      <SeoComponents />
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        canonical="https://techcelerant.com/about"
      />

      <main>
        <section
          style={{ "--bg-02": "white", color: "black", "--bg-op": "0.05" }}
          className={` body-top-section-rotate min-h-[100%] px-[2rem]  sm:mt-[0px]`}
        >
          <Section01 data={firstSection} />
        </section>

        <section
          style={{ "--bg-02": "black", color: "white", "--bg-op": "0.05" }}
          className={` body-top-section-rotate min-h-[100%]  px-[2rem]`}
        >
          <Section02 data={secondSection} />
        </section>

        <section
          style={{ "--website-bg-02": "white", padding: "80px 2rem 80px 2rem" }}
          className="body-top-section-rotate-3"
        >
          <OurPartners
            data={ourPartners}
            width="max-w-[90rem]"
            paddingL="pl-[0px] px-[2rem]"
          />
        </section>

        <section
          style={{
            "--website-bg-02": "black",
            padding: "80px 0px 80px 0px",
            color: "white",
          }}
          className="body-top-section-rotate-3 px-[2rem]"
        >
          <Section03 data={fourthSection} />
        </section>

        <section
          style={{ "--website-bg-02": "black" }}
          className="body-top-section-rotate-3 py-[2rem] -mt-[5rem]"
        >
          <div className="max-w-[90rem] m-auto mb-[2rem] sm:-mb-[2.5rem] pb-[2.5rem] ">
            <Form isAnimate={true} isVisible={true} width="max-w-[90rem]" />
          </div>
        </section>
      </main>
    </>
  );
};
export default About;

export const getServerSideProps = async () => {
  // context.res.setHeader('Cache-Control', 'public, max-age=300');
  const query = `*[ _type == "about"][0]`;
  const aboutPage = await client.fetch(query);

  return {
    props: {
      aboutPage,
    },
  };
};
